import React, { Component } from 'react';
import { connect } from 'react-redux';
import { authLogout } from '../redux/authActionCreators';
import { Redirect } from 'react-router-dom';

const mapDispatchToProps = dispatch => {
    return {
        logout: () => dispatch(authLogout())
    }
}

class Logout extends Component {
    componentDidMount() {
        this.props.logout();
    }
    render() {
        return (
            <Redirect to='/' />
        )
    }
}

export default connect(null, mapDispatchToProps)(Logout);